import React from "react";
import { t } from "@lingui/macro";
// Our modules
import { AppList, MoreLink, Section } from "../../../components";
import { i18n } from "idc-ui-react";

const Apps = ({ apps }) => {
  if (!apps) return null;

  return (
    <Section text="IDC Apps" slide="right">
      <AppList apps={apps} />
      <MoreLink link="/apps" text={i18n._(t`Explore all apps`)} />
    </Section>
  );
};

export default Apps;
